module.exports = __webpack_public_path__ + "static/media/iconRefresh.4f127ed5.svg";